import useSWR from 'swr'
import { guardClient } from '../_axios'

/**
 * 選択した会社情報の取得
 * [get]/company/:companyId
 */

type Sales = {
  firstName: string
  lastName: string
  department: string
  post: string
  cellPhone: string
  mail: string
}
export type CompanyTask = {
  id: string
  title: string
  description: string | null
  dueDate: string | null
  creator: string
  isDeleted: boolean
  columnId: string
}
export type SelectCompanyType = {
  id: number
  name: string
  frequencyCode?: 'NONE' | 'HIGH' | 'MIDDLE' | 'LOW'
  tagCode?:
    | 'NO_DISTRIBUTION'
    | 'PROJECT_PERSONAL'
    | 'PROJECT'
    | 'PROJECT_DEVELOPMENT'
    | 'PROJECT_FOUNDATION'
    | 'HUMAN_RESOURCES_BP'
    | 'HUMAN_RESOURCES_P'
  specialty: string
  specialtyIndustry: string
  postCode: string
  address: string
  homePhone: string
  homepage: string
  establishment: string
  invoice: string
  salesValue: number
  properValue: number
  bpValue: number
  deliverAddress: string
  dispatchLicense?: boolean
  dispatchLicenseNumber: string
  pMark?: boolean
  isms?: boolean
  memo: string
  focusCustomer?: boolean
  version: string
  updateAt: string
  sales: Sales[]
  tasks: CompanyTask[]
}
type Response = { data: SelectCompanyType }

const selectCompanyFetcher = (urlTail: string) => {
  const response = guardClient.get<Response>(urlTail).then((r) => r.data)
  return response
}
export const useSelectCompany = (companyId: string) => {
  const path = `/company/${companyId}`

  const { data, mutate } = useSWR(path, selectCompanyFetcher, {
    onErrorRetry: () => {
      return
    }
  })
  return { data: data?.data, mutate }
}
